import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'

import { notification } from 'redux/modules/app'
import { awardUnits as awardUnitsApi } from 'redux/modules/api'
import { checkEmail } from 'redux/modules/api/asyncValidations'
import { awardUnitScheme } from 'models'
import config from 'config'

function decorator() {
  return ComposedComponent => {
    @connect(
      ({ api, app }) => ({
        awardUnits: api.awardUnits,
        localeId: app.locale.id
      }),
      { ...awardUnitsApi, notification, push, checkEmail }
    )
    class AwardUnits extends Component {
      static propTypes = {
        localeId: PropTypes.number.isRequired,
        checkEmail: PropTypes.func.isRequired,
        fetchAwardUnits: PropTypes.func.isRequired,
        createAwardUnit: PropTypes.func.isRequired,
        checkOperatingAuthorities: PropTypes.func.isRequired,
        notification: PropTypes.func.isRequired,
        push: PropTypes.func.isRequired
      }

      handleAwardUnitCreate = fields => {
        const { configuration } = this.props
        let awardUnitData = {}

        try {
          awardUnitData = awardUnitScheme(fields, this.props.localeId, configuration)
        } catch (error) {
          console.log('error', error)
        }

        return this.props
          .createAwardUnit(awardUnitData)
          .then(this.handleCreateSuccess)
          .catch(this.handleError)
      }

      handleCheckEmail = params =>
        this.props.checkEmail(params).then(({ body }) => body || false)

      handleCreateSuccess = () => {
        this.props.notification('Award Unit has been created', {
          status: 'success',
          intlKey: 'notifications.award_unit_has_been_created'
        })
        this.props.push(`${config.publicPath}/register/award-unit/success`)
      }

      handleError = err => {
        this.props.notification(
          err.body &&
            (err.body.userMessage || err.body.developerMessage || 'Error'),
          'error'
        )
        throw err
      }

      handleFetchAwardUnits = (
        { countryId, leaderEmail },
        { organizationId, parentOrganizationId } = {}
      ) =>
        this.props.fetchAwardUnits(countryId, {
          leaderEmail,
          organizationId,
          parentOrganizationId
        })

      handleCheckOperatingAuthorities = ({
        name = '',
        countryId,
        leaderEmail
      }) => this.props.checkOperatingAuthorities(name, countryId, leaderEmail)

      render() {
        return (
          <ComposedComponent
            {...this.props}
            checkEmail={this.handleCheckEmail}
            handleAwardUnitCreate={this.handleAwardUnitCreate}
            checkOperatingAuthorities={this.handleCheckOperatingAuthorities}
            onFetchAwardUnits={this.handleFetchAwardUnits}
          />
        )
      }
    }
    return AwardUnits
  }
}

export default decorator
